import React from "react";
import PropTypes from "prop-types";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import RemarksForm from "../RemarksForm";
import CircleForm from "../CircleForm";

const TopSection = props => {
  const isCircleProgramPage =
    props.isCircleProgram || window.location.pathname === "/circle";
  const topsectionClassName = isCircleProgramPage
    ? "wc-topsection-circleimagecontainer"
    : "wc-topsection-imagecontainer";

  return (
    <GridContainer className="nw-desktop-only">
      <GridRow className={topsectionClassName}>
        <GridColumn className="nwc-grid-col-sm-4 wc-topsection-imagecol">
          {isCircleProgramPage ? (
            <CircleForm
              containerclassName="wc-topsection-formcontainer"
              formclassName="wc-topsection-form"
            />
          ) : (
            <RemarksForm
              containerclassName="wc-topsection-formcontainer"
              formclassName="wc-topsection-form"
            />
          )}
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

TopSection.defaultProps = {
  isCircleProgram: false,
};

TopSection.propTypes = {
  isCircleProgram: PropTypes.bool,
};

export default TopSection;
